import moment from 'moment'
import find from 'lodash/find'
import first from 'lodash/first'
import isEmpty from 'lodash/isEmpty'
import { prismicRichTextAsHTML } from 'prismic-utils'
import { deserializePage, fetchPages } from 'supporticon/api/pages'
import { deserializeLeaderboard, fetchLeaderboard } from 'supporticon/api/leaderboard'
import { isJustGiving } from '../../../lib/environment'
import c from '../constants'

export const fetchProjects = (projects, campaign) =>
  isJustGiving()
    ? fetchJustgivingProjects(projects, campaign)
    : fetchEverydayheroProjects(projects)

// JustGiving
const fetchJustgivingProjects = (projects, campaign) => dispatch => {
  if (!campaign) {
    throw new Error('To use projects on JustGiving, please ensure a Campaign GUID has been provided')
  }

  const activeProjects = filterActiveProjects(projects.items)
  const activeProjectSlugs = activeProjects.map(project => project.uid)

  return fetchLeaderboard({ campaign, limit: 50 })
    .then(pages => pages.map(deserializeLeaderboard))
    .then(pages => pages.filter(page => activeProjectSlugs.indexOf(page.slug) !== -1))
    .then(pages => mergeProjectData(pages, activeProjects))
    .then(data => dispatch({ type: c.SUCCESS, payload: { data } }))
    .catch(error => {
      dispatch({ type: c.FAILURE })
      return Promise.reject(error)
    })
}

// Everydayhero
export const fetchEverydayheroProjects = projects => dispatch => {
  const activeProjects = filterActiveProjects(projects.items)
  const projectIDs = activeProjects.map((project) => project.uid)
  const ids = projectIDs.join(',')

  return fetchPages({ allPages: true, ids })
    .then(pages => fetchEverydayheroDonations(pages))
    .then(pages => mergeProjectData(pages, activeProjects))
    .then(data => dispatch({ type: c.SUCCESS, payload: { data, projectIDs } }))
    .catch((error) => {
      dispatch({ type: c.FAILURE })
      return Promise.reject(error)
    })
}

const fetchEverydayheroDonations = pages => {
  const firstPage = first(pages)
  const isTeam = firstPage && firstPage.owner_type === 'Team'

  const ids = isTeam
    ? pages.map(page => page.team_member_uids.join(','))
    : pages.map(page => page.id)

  const params = {
    group_by: isTeam ? 'teams' : 'pages',
    page_ids: ids.join(',')
  }

  return fetchLeaderboard(params)
    .then(leaders => pages.map(page => {
      const leader = find(leaders, leader => (leader.page ? leader.page.id : leader.team.team_page_id) === page.id)
      return {
        ...leader && deserializeLeaderboard(leader),
        ...deserializePage(page),
        raised: page.amount.cents / 100,
        target: page.target_cents / 100
      }
    }))
}

const mergeProjectData = (pages, projects) =>
  pages.map(page => {
    const project = find(projects, project => project.uid === String(page.id) || project.uid === page.slug)

    return {
      ...project,
      ...page,
      totalDonations: page.totalDonations || 0,
      name: project.overridePageName || page.name,
      story: isEmpty(project.overridePageStory)
        ? page.story
        : prismicRichTextAsHTML(project.overridePageStory),
      image: isEmpty(project.overridePageImage)
        ? page.image
        : project.overridePageImage.url

    }
  })

const filterActiveProjects = (projects = []) => (
  projects.filter(({
    endDate,
    startDate
  }) => {
    const isStarted = !startDate || moment(startDate).isBefore()
    const isNotFinished = !endDate || moment(endDate).endOf('day').isAfter()
    return isStarted && isNotFinished
  })
)



// WEBPACK FOOTER //
// ./store/projects/actions/index.js